import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { UrlService } from '@eforall/common';

export interface ActionButton {
	order: number
	header: string,
	subText?: string,
	routerLink?: string,
	url?: string,
	callBack?: () => void,
	disabled?: boolean,
	complete?: boolean,
	width: 'half' | 'full'
	color: ActionButtonColor,
	fill: 'infill' | 'outline'
}

export const enum ActionButtonColor {
	Primary = 'primary',
	Secondary = 'secondary',
	AltSecondary = 'alt-secondary',
	Standard = 'standard'
}

@Component({
	selector: 'action-matrix',
	imports: [],
	templateUrl: './action-matrix.widget.html',
	styleUrl: './action-matrix.widget.scss'
})
export class ActionMatrixWidget {
	private router = inject(Router);
	public urlService = inject(UrlService);

	public data = input.required<ActionButton[]>();
	public sortedData = computed(() => {
		return this.data().sort((a, b) => a.order < b.order ? -1 : 1);
	});

	onClick(button: ActionButton) {
		if (!button.disabled) {
			if (button.routerLink) {
				this.router.navigate([this.urlService.withCurrentLanguage(button.routerLink)]);
			} else if (button.url) {
				window.open(button.url, '_blank');
			} else if (button.callBack) {
				button.callBack();
			}
		}
	}
}
